module.exports = __webpack_public_path__ + "static/media/5DPO23.ce2f7a47.jpg";